import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHeading } from "../common/SectionHeading";
import { Reveal } from "../common/Reveal";
import { EXPERIENCES } from "../../lib/data";

export const Experiences = () => (
    <section data-testid="experiences-section" className="bg-ink text-white py-24 md:py-32 overflow-hidden">
        <div className="mx-auto max-w-[1440px] px-5 md:px-10">
            <div className="flex flex-wrap items-end justify-between gap-8">
                <SectionHeading
                    chapter="04"
                    kicker="The Gigs"
                    title="Showtime Experiences"
                    copy="One setup. Endless occasions. We spin, pop and serve — your crowd does the rest."
                    dark
                    testid="experiences-heading"
                />
                <Reveal delay={0.1} className="mb-14 md:mb-20">
                    <Link
                        to="/book"
                        data-testid="experiences-book-cta"
                        className="inline-flex items-center gap-2 rounded-full bg-pink px-8 py-4 font-oswald uppercase tracking-widest text-ink hover:bg-white transition-colors duration-300 active:scale-95"
                    >
                        Book The Show <ArrowRight size={16} />
                    </Link>
                </Reveal>
            </div>
        </div>
        <Reveal>
            <div
                data-testid="experiences-scroller"
                className="flex gap-5 overflow-x-auto snap-x snap-mandatory px-5 md:px-10 pb-6 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
            >
                {EXPERIENCES.map((exp, i) => (
                    <Link
                        key={exp.title}
                        to="/book"
                        data-testid={`experience-card-${i}`}
                        className="group relative shrink-0 w-72 md:w-80 h-[26rem] snap-start overflow-hidden rounded-3xl"
                    >
                        <img
                            src={exp.image}
                            alt={exp.title}
                            loading="lazy"
                            className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/15 to-transparent" />
                        <div className="absolute top-5 left-5 font-oswald text-pink text-sm tracking-[0.3em]">
                            {String(i + 1).padStart(2, "0")}
                        </div>
                        <div className="absolute inset-x-0 bottom-0 p-6">
                            <h3 className="font-oswald uppercase text-2xl leading-tight">{exp.title}</h3>
                            <p className="mt-2 text-sm text-zinc-300 max-h-0 overflow-hidden opacity-0 transition-[max-height,opacity] duration-500 group-hover:max-h-24 group-hover:opacity-100">
                                {exp.copy}
                            </p>
                        </div>
                    </Link>
                ))}
            </div>
        </Reveal>
    </section>
);
